import { css } from '@emotion/react';

const styles = {
  paragraphAndButtonPadding: () => css`
    padding-bottom: var(--cds-spacing-300);
  `,
  modalContentSegmentPadding: () => css`
    padding-bottom: var(--cds-spacing-600);
  `,
};

export default styles;
